import { HttpClient, httpResource, HttpResourceRef } from "@angular/common/http";
import { inject, Injectable, Signal } from "@angular/core";
import { toSignal } from "@angular/core/rxjs-interop";
import { filterNonEmptyProperties } from "@kno2/utils";
import { firstValueFrom, map } from "rxjs";
import { LicenseType, LicenseTypePagedResult, LicenseTypeQueryOptions } from "./license-types.models";

@Injectable({
    providedIn: "root"
})
export class AdminLicenseTypesService {
    private readonly httpClient = inject(HttpClient);

    public getAdminLicenseTypes = (): Signal<LicenseType[]> =>
        toSignal(this.httpClient.get<{ items: LicenseType[] }>("/api/admin/licensetypes").pipe(map((response) => response.items)), { initialValue: [] });

    public getAdminLicenseTypesResource = (query: Signal<LicenseTypeQueryOptions>): HttpResourceRef<LicenseTypePagedResult> =>
        httpResource(() => ({ url: "/api/admin/licensetypes", params: filterNonEmptyProperties(query()) }));

    public getAdminLicenseTypesAsync(search: string = ""): Promise<LicenseType[]> {
        return firstValueFrom(
            this.httpClient.get<{ items: LicenseType[] }>("/api/admin/licensetypes", { params: { search } }).pipe(map((response) => response.items))
        );
    }

    public getAdminLicenseType = (id: string): Signal<LicenseType> => toSignal(this.httpClient.get<LicenseType>(`/api/admin/licensetypes/${id}`));

    public createAdminLicenseType = (licenseType: LicenseType): Promise<LicenseType> =>
        firstValueFrom(this.httpClient.post<LicenseType>("/api/admin/licensetypes", licenseType));

    public updateAdminLicenseType = (licenseType: LicenseType): Promise<LicenseType> =>
        firstValueFrom(this.httpClient.put<LicenseType>(`/api/admin/licensetypes/${licenseType.id}`, licenseType));

    public deleteAdminLicenseType = (id: string): Promise<void> => firstValueFrom(this.httpClient.delete<void>(`/api/admin/licensetypes/${id}`));

    public checkNameExists = (name: string, excludeId?: string): Promise<boolean> => {
        const params: { name: string; excludeId?: string } = excludeId ? { name, excludeId } : { name };
        return firstValueFrom(this.httpClient.get<boolean>("/api/admin/licensetypes/exists", { params }));
    };
}
